const RelatedList = require('module/user/related_list')
const PortfolioItem = require('./portfolio_item')

const PortfolioList = RelatedList.extend({

    id: 'portfolio',

    model: PortfolioItem,

    comparator: 'order',

    initialize() {
        this.listenTo(this, 'change:order', this.sort)
    },

})

module.exports = PortfolioList
